/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const FR2052AComment = ({
    getFR2052AUser, fr2052aComment, setFR2052AComment, commentLoading, addFR2052AComment,
    loading, getUserCommentsForFR2052A, fr2052aEdit, handleFR2052AClick, fr2052aShow,
    fr2052aTarget, onFR2052AEditClick, onFR2052AClickDelete, fr2052aSelectedIndex,
    fr2052aSelectedComment, setFR2052ASelectedComment, onFR2052ACancelClick, onFR2052AClickSave,
}) => (
    <CommentsSection
        getUser={getFR2052AUser}
        comment={fr2052aComment}
        setComment={setFR2052AComment}
        commentLoading={commentLoading}
        addComment={addFR2052AComment}
        loading={loading}
        getUserComments={getUserCommentsForFR2052A}
        edit={fr2052aEdit}
        handleClick={handleFR2052AClick}
        show={fr2052aShow}
        target={fr2052aTarget}
        onEditClick={onFR2052AEditClick}
        onClickDelete={onFR2052AClickDelete}
        selectedIndex={fr2052aSelectedIndex}
        selectedComment={fr2052aSelectedComment}
        setSelectedComment={setFR2052ASelectedComment}
        onCancelClick={onFR2052ACancelClick}
        onClickSave={onFR2052AClickSave}
    />
);

export default FR2052AComment;
